<template>
    <div>
        <headerNotice routerName="系统信息"></headerNotice>
        <!-- 系统信息 -->
        <div class="systemInfo">
            <h1>系统信息</h1>
            <ul>
                <li>
                    <span>服务器操作系统:</span>
                    <p>Linux (114.55.34.251)</p>
                </li>
                <li>
                    <span>Web 服务器:</span>
                    <p>nginx/1.10.2</p>
                </li>
                <li>
                    <span>.NET 版本:</span>
                    <p>5.6.30</p>
                </li>
                <li>
                    <span>MySQL 版本:</span>
                    <p>5.5.56</p>
                </li>
                <li>
                    <span>安全模式:</span>
                    <p>否</p>
                </li>
                <li>
                    <span>安全模式GID:</span>
                    <p>否</p>
                </li>
                <li>
                    <span>Socket 支持:</span>
                    <p>是</p>
                </li>
                <li>
                    <span>时区设置:</span>
                    <p>Asia/Shanghai</p>
                </li>
                <li>
                    <span>GD 版本:</span>
                    <p>GD2 ( JPEG GIF PNG)</p>
                </li>
                <li>
                    <span>Zlib 支持:</span>
                    <p>是</p>
                </li>
                <li>
                    <span>IP 库版本:</span>
                    <p>20071024</p>
                </li>
                <li>
                    <span>文件上传的最大大小:</span>
                    <p>40M</p>
                </li>
                <li>
                    <span>程序版本:</span>
                    <p>v2.2.2 RELEASE 20170629</p>
                </li>
                <li>
                    <span>安装日期:</span>
                    <p>2017-05-02</p>
                </li>
                <li>
                    <span>编码:</span>
                    <p>UTF-8</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {

        }
    },
    components: {
        headerNotice,
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style lang='scss' scoped>
//  系统信息
.systemInfo {
    margin: 0 250px;
    margin-top: 20px;
    border: 1px solid #999;
    padding-bottom: 50px;
    background: #fff;
    h1 {
        background: #F3F3F3;
        padding: 10px 20px;
    }
    ul {
        width: 80%;
        margin: 0 auto;
        margin-top: 50px;
        border: 1px solid #999;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: border-box;
        li {
            width: 50%;
            height: 50px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            &:nth-child(2n + 1) {
                border-bottom: 1px solid #999;
                border-right: 1px solid #999;
            }
            &:nth-child(2n) {
                border-bottom: 1px solid #999;
            }
            &:nth-last-child(1) {
                border-bottom: none;
            }
            span {
                font-size: 14px;
                display: block;
                height: 100%;
                line-height: 50px;
                text-align: center;
                width: 35%;
                background: #f9fafc;
                border-right: 1px solid #999;
            }
            p {
                padding-left: 50px;
                font-size: 12px;
                color: #666;
            }
        }
    }
}
</style>